import { Layout, Section } from 'layout';
import { NotificationProvidersScreen } from 'pages/notification-providers/screens/notification-providers-screen';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

const NotificationProvidersPage = () => {
  const match = useRouteMatch();

  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Route exact path={match.url} component={NotificationProvidersScreen} />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default NotificationProvidersPage;
